module.exports = __webpack_public_path__ + "static/img/HotSend1.dc9f70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HotSend1.png
// module id = 4Dzo
// module chunks = 0